import React from 'react';
import { useTranslation } from 'react-i18next';
import { useExperienceWizard } from 'core/contexts/experienceWizard';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Box } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import ActionButtons from 'modules/Pricing/PriceGroupWizard/components/ActionButtons';
import MultimediaFormFields from 'modules/Experience/components/MultimediaFormFields';

const MultimediaForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.multimedia_form.${key}`);
    const { stepData, handleBack, handleNext, updateStepData, STEP_KEYS } = useExperienceWizard();

    const handleSubmit = (values) => {
        updateStepData(STEP_KEYS.STEP_4, values);
        handleNext();
    };

    const validateForm = (values) => {
        const errors = {};

        return errors;
    };

    return (
        <Form
            onSubmit={handleSubmit}
            mutators={{ ...arrayMutators }}
            validate={validateForm}
            initialValues={stepData[STEP_KEYS.STEP_4]}
            render={({ handleSubmit, form }) => {
                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%', maxWidth: '480px' }}>
                        <Box component="section">
                            <Title title={translate('title')} description={translate('description')} />

                            <MultimediaFormFields form={form} />

                            <ActionButtons
                                handleSubmit={(e) => {
                                    return handleSubmit(e);
                                }}
                                handleBack={handleBack}
                            />
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default MultimediaForm;
